module.exports = __webpack_public_path__ + "img/lock.a4222d0b.svg";